import { connect } from 'react-redux';
import StripSiteSearchQueryParams from './StripSiteSearchQueryParams';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(StripSiteSearchQueryParams);
